import React from 'react';
import { yellowCheck } from '../../../assets/images/dashboard-business';

type TProps = {
  active: number;
  isStageTwoComplete: boolean;
  isStageOneComplete: boolean;
  isStageThreeComplete: boolean;
  setActive: React.Dispatch<React.SetStateAction<number>>;
};
export const ProgressLine = ({
  active,
  isStageOneComplete,
  isStageTwoComplete,
  isStageThreeComplete,
  setActive,
}: TProps) => {
  return (
    <div className='hidden sl:block relative mr-[4vw] mb-[100px]'>
      <hr className='h-[1px] bg-[#9C9C9C] w-full' />
      <div className='flex ml-2 justify-between items-center absolute top-[-10px] w-full'>
        <div>
          <div className='flex justify-center'>
            {isStageOneComplete ? (
              <img src={yellowCheck} className='w-[22px] h-[22px]' />
            ) : (
              <div
                className={[
                  'rounded-[50%] h-[20px] w-[20px]',
                  isStageOneComplete || active === 1 ? 'bg-[#F8B400]' : 'bg-[#9C9C9C]',
                ].join(' ')}
              ></div>
            )}
          </div>
          <div
            className={[
              'mt-2 cursor-pointer',
              isStageOneComplete || active === 1
                ? 'font-[600] text-[#028789]'
                : 'font-[400] text-[#9C9C9C]',
            ].join(' ')}
            onClick={() => setActive(1)}
          >
            Personal Data
          </div>
        </div>
        <div>
          <div className='flex justify-center'>
            {isStageTwoComplete ? (
              <img src={yellowCheck} className='w-[22px] h-[22px]' />
            ) : (
              <div
                className={[
                  'rounded-[50%] h-[20px] w-[20px]',
                  isStageTwoComplete || active === 2 ? 'bg-[#F8B400]' : 'bg-[#9C9C9C]',
                ].join(' ')}
              ></div>
            )}
          </div>
          <div
            className={[
              'mt-2 cursor-pointer',
              isStageTwoComplete || active === 2
                ? 'font-[600] text-[#028789]'
                : 'font-[400] text-[#9C9C9C]',
            ].join(' ')}
            onClick={() => setActive(2)}
          >
            Residential Address
          </div>
        </div>
        <div>
          <div className='flex justify-center'>
            {isStageThreeComplete ? (
              <img src={yellowCheck} className='w-[22px] h-[22px]' />
            ) : (
              <div
                className={[
                  'rounded-[50%] h-[20px] w-[20px]',
                  isStageThreeComplete || active === 3 ? 'bg-[#F8B400]' : 'bg-[#9C9C9C]',
                ].join(' ')}
              ></div>
            )}
          </div>
          <div
            className={[
              'mt-2 cursor-pointer',
              isStageThreeComplete || active === 3
                ? 'font-[600] text-[#028789]'
                : 'font-[400] text-[#9C9C9C]',
            ].join(' ')}
            onClick={() => setActive(3)}
          >
            Upload Documents
          </div>
        </div>
      </div>
    </div>
  );
};
